<template>
  <div class="presupuesto-interno-usuarios-propuesta">
    <b-card header= "Usuarios de la Propuesta" class="presupuesto-header">
      <b-btn class="btn-collapse-card" 
          variant="primary" 
          size="sm"
          @click.prevent="showUsuariosPropuesta= !showUsuariosPropuesta">
        <i :class="showUsuariosPropuesta ? 'fa fa-caret-up' : 'fa fa-caret-down'"></i>
      </b-btn>
      <b-collapse id="headerUsuarios" class="mt-2" v-model="showUsuariosPropuesta">
        <b-row>
          <b-col>
            <b-table hover
                responsive="sm" 
                class="registro"
                :items="usuariosPropuestaDatos" 
                :fields="usuariosFields">
              <div slot="table-busy" class="text-center">
                <b-spinner class="table-spinner" label="Spinning" />
              </div>
              <template v-slot:cell(usuario)="data">
                {{ data.item.usuario.trim() + ' - ' + data.item.usuarioRol.trim() }}
              </template>
            </b-table>
          </b-col>
        </b-row>
      </b-collapse>
    </b-card>
  </div>
</template>

<script>
import { mapState } from 'vuex';
import { createHelpers } from 'vuex-map-fields';

const { mapFields } = createHelpers({
  getterType: 'presupuestoInternoDatos/getField',
  mutationType: 'presupuestoInternoDatos/updateField',
});

export default {
  name: 'PresupuestosInternosUsuariosData',
  data () {
    return {
      usuariosFields: [
        {
          key: 'usuario',
          label: 'Usuarios',
        },
      ],

      showUsuariosPropuesta: false,

      labelCols: 2,
    }
  },
  computed: {
    ...mapFields([
      'usuariosPropuestaDatos',
    ]),
  },  
  created() {
  },
  destroyed() {
  },
}
</script>

<style>
  .presupuesto-interno-usuarios-propuesta table thead th {
    border-top: none;
  }
  .presupuesto-interno-usuarios-propuesta table tr.table-inactivo {
    color: #a9a9a9;
  }
</style>